module.exports = __webpack_public_path__ + "static/media/bg-landingpage.97b89b97.svg";